<template>
  <component
    :is="tag"
    class="ui-typography"
    :class="[
      `ui-typography--${variant}`,
      `ui-typography--${tone}`
    ]"
  >
    <slot />
  </component>
</template>

<script>
const VARIANTS = [
  'header01',
  'header02',
  'header03',
  'body',
  'caption',
  'small'
]

export default {
  name: 'UiTypography',

  props: {
    variant: {
      type: String,
      default: 'body',
      validator: value => VARIANTS.includes(value)
    },
    tag: {
      type: String,
      default: 'span'
    },
    tone: {
      type: String,
      default: 'dark',
      validator: value => ['dark', 'muted', 'inherit'].includes(value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './tokens';

.ui-typography {
  margin: 0;
  font-family: "Helvetica", Arial, sans-serif;
  font-style: normal;

  &--dark {
    color: $ui-color-text;
  }

  &--muted {
    color: $ui-color-muted;
  }

  &--inherit {
    color: inherit;
  }

  &--header01 {
    font-size: vw(32);
    font-weight: 300;
    line-height: 1.2;
    text-transform: uppercase;
  }

  &--header02 {
    font-size: vw(24);
    font-weight: 300;
    line-height: 1.2;
    text-transform: uppercase;
  }

  &--header03 {
    font-size: vw(14);
    font-weight: 400;
    line-height: 1.2;
    text-transform: uppercase;
  }

  &--body {
    font-size: vw(18);
    font-weight: 300;
    line-height: 1.3;
  }

  &--caption {
    font-size: vw(14);
    font-weight: 400;
    line-height: 1.3;
  }

  &--small {
    font-size: vw(12);
    font-weight: 400;
    line-height: 1.3;
  }
}

@include max-width(mobile) {
  .ui-typography {
    &--header01 {
      font-size: vwm(24);
    }

    &--header02 {
      font-size: vwm(18);
    }

    &--header03 {
      font-size: vwm(12);
    }

    &--body {
      font-size: vwm(14);
    }

    &--caption {
      font-size: vwm(12);
    }

    &--small {
      font-size: vwm(10);
    }
  }
}
</style>
